import { createSelector } from 'reselect'
import { FacebookSettingsRootState } from '../facebookSettingsRoot.reducer'

export const getTheme = createSelector(
  (state: FacebookSettingsRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: FacebookSettingsRootState) => state.commonStore.user,
  (state) => state,
)

export const namedRequestAll = createSelector(
  [
    (state: FacebookSettingsRootState) => state.commonStore.requests,
    (state: FacebookSettingsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type)
  },
)

export const namedRequestInProgress = createSelector(
  [
    (state: FacebookSettingsRootState) => state.commonStore.requests,
    (state: FacebookSettingsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestData = createSelector(
  [
    (state: FacebookSettingsRootState) => state.commonStore.requests,
    (state: FacebookSettingsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
